import React, { useEffect, useRef, useState } from 'react';

type Slide = {
    image: string; // Path under public/images/hero e.g. "/images/hero/slide1.jpg"
    lines: string[]; // big heading lines on the right pane
    cta?: { label: string; href: string };
};

// Drop your images into public/images/hero and update these filenames only
const SLIDES: Slide[] = [
    {
        
        image: '/jeevan-jyoti-ngo/images/about/larm-rmah-AEaTUnvneik-unsplash.jpg',
        lines: ['EMPOWER WOMEN', 'THROUGH SKILL', 'DEVELOPMENT'],
        cta: { label: 'Volunteer', href: '/contact' },
    },
    {
        image: '/jeevan-jyoti-ngo/images/about/sporlab-f8ld5zt3a3k-unsplash.jpg',
        lines: ['SUPPORT RURAL', 'EDUCATION', 'AND HEALTHCARE'],
        cta: { label: 'Join Us', href: '/about' },
    },
    {
        image: '/jeevan-jyoti-ngo/images/about/atul-pandey-0f3bZHXZSz8-unsplash.jpg',
        lines: ['UTTARKASHI FLASH', 'FLOODS', 'EMERGENCY HELP','FAMILIES IN CRISES'],
        cta: { label: 'Donate Now', href: '/donate' },
    },
];

const AUTO_MS = 5000;

const HeroCarousel: React.FC = () => {
    const [index, setIndex] = useState<number>(0);
    const timerRef = useRef<number | null>(null);
    const total = SLIDES.length;

    useEffect(() => {
        start();
        return stop;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [index]);

    const start = () => {
        stop();
        timerRef.current = window.setTimeout(() => {
            setIndex((prev) => (prev + 1) % total);
        }, AUTO_MS);
    };

    const stop = () => {
        if (timerRef.current) {
            window.clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };

    const goTo = (i: number) => setIndex((i + total) % total);
    const prev = () => setIndex((i) => (i - 1 + total) % total);
    const next = () => setIndex((i) => (i + 1) % total);

    return (
        <div className="relative w-full bg-white h-[340px] md:h-[520px]" onMouseEnter={stop} onMouseLeave={start}>
            {SLIDES.map((slide, i) => (
                <div key={i} className={`${i === index ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'} transition-opacity duration-700 ease-out absolute inset-0`}> 
                    <div className="grid grid-cols-1 md:grid-cols-3 h-[340px] md:h-[520px]">
                        {/* Left image spans 2 cols on desktop */}
                        <div className="md:col-span-2 h-[340px] md:h-[520px] overflow-hidden">
                            <img src={slide.image} alt="slide" className="w-full h-full object-cover" />
                        </div>
                        {/* Right panel */}
                        <div className="md:col-span-1 bg-[#5ec1c8] h-full flex items-center justify-center p-6 md:p-10">
                            <div>
                                <div className="space-y-2">
                                    {slide.lines.map((l, li) => (
                                        <div key={li} className="text-white font-extrabold leading-tight text-3xl md:text-5xl drop-shadow">
                                            {l}
                                        </div>
                                    ))}
                                </div>
                                {slide.cta && (
                                    <a href={slide.cta.href} className="inline-block mt-6 bg-white text-gray-900 font-semibold rounded-full px-6 py-3 shadow">
                                        {slide.cta.label}
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ))}

            {/* Controls */}
            <button aria-label="Previous slide" className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/40 text-white rounded-full w-9 h-9 grid place-items-center z-10" onClick={prev}>‹</button>
            <button aria-label="Next slide" className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/40 text-white rounded-full w-9 h-9 grid place-items-center z-10" onClick={next}>›</button>

            {/* Indicators */}
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2 z-10">
                {SLIDES.map((_, i) => (
                    <button key={i} aria-label={`Go to slide ${i + 1}`} className={`w-2.5 h-2.5 rounded-full ${i === index ? 'bg-white' : 'bg-white/50'}`} onClick={() => goTo(i)} />
                ))}
            </div>
        </div>
    );
};

export default HeroCarousel;
